import * as React from 'react';

import { Grid, Spacer, Typography } from '@emburse/ui-core';

import * as style from './SignUpReviews.styl';

interface SignUpReviewsProps {
  initialSignupPage?: boolean;
}

export const SignUpReviews: React.FC<SignUpReviewsProps> = ({ initialSignupPage }) => {
  const reviews: Record<string, string>[] = initialSignupPage
    ? [
        {
          text: '"With Emburse Spend, we’ve gained more visibility into our operating expenses and increased control of our spend with a platform that can easily scale with us as we grow."',
          author: 'Morgan McLintic, CEO of Firebrand'
        },
        {
          text: '"We made it easier to volunteer for VoteRiders by using Emburse Spend to broaden access to organizational funds and reduce the need for personal reimbursements."',
          author: 'Shane Epps, Operations Manager, VoteRiders'
        },
        {
          text: '"The Emburse Spend system is great. We love the ease of managing both cards and users while consistently capturing essential expense details."',
          author: 'David Wendrychowicz, VP of Finance, GF Sports & Entertainment'
        }
      ]
    : [
        {
          text: '"With the increased visibility and control over spending, we have a huge increase in policy compliance."',
          author: 'Melanie Sacca, VP/Director of Finance, NAF'
        },
        {
          text: '"Emburse Cards is the best solution for a start-up company with limited access to traditional purchasing cards. Previously we were buying prepaid cards that were expensive, time-consuming, and provided poor visibility into spending."',
          author: 'Todd Paul, Controller, American Nitrile'
        }
      ];
  return (
    <Grid container item className={style.global} justifyContent={'center'}>
      <Grid container item alignItems="center" wrap="nowrap" spacing={4} direction="column">
        {reviews.map((review, i) => {
          return (
            <Grid item key={i}>
              <div className="review">
                <Typography variant="body1">{review.text}</Typography>
                <Spacer size={'16px'} />
                <Typography variant="caption">-- {review.author}</Typography>
              </div>
            </Grid>
          );
        })}
      </Grid>
    </Grid>
  );
};

export default SignUpReviews;
